import React from 'react'
import { CollectDataForm } from 'src/components/collect-data-form/CollectDataForm'

export const FormPage = () => {
  return <CollectDataForm />
}
